<template>
    <v-container fluid class="my-0 px-0  py-0">
        <q-content-submenu ref="contentMenu"></q-content-submenu>
        <v-row wrap class="mx-7" style="padding-top:100px;">
            <v-col cols="12">
                <h2>Submit New Application</h2>
            </v-col>
            <v-col cols="12">
                <q-new-application></q-new-application>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import QContentSubmenu from '@/components/navigation/Submenus/QContentSubmenu.vue'
import QNewApplication from '@/components/applications/QNewApplication.vue'
export default {
    data() {
        return {

        }
    },
    components: {
        QContentSubmenu,
        QNewApplication
    }
}
</script>